import {
  SET_OPEN_MODAL_REVISOR,
  SET_OPEN_MODAL_VERBAS_COMUNICADO,
  SET_OPEN_MODAL_REVISOR_BLOQUEIO,
  SET_OPEN_MODAL_BLOQUEIO_MODULO
} from "../actions/actionTypes";

const INITIAL_STATE = {
  openModalVerbasComunicado: false,
  openModalRevisor: false,
};

// eslintdisablenextline
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_OPEN_MODAL_VERBAS_COMUNICADO:
      return {
        ...state,
        openModalVerbasComunicado: action.payload,
      };

    case SET_OPEN_MODAL_REVISOR:
      return {
        ...state,
        openModalRevisor: action.payload,
      };

    case SET_OPEN_MODAL_REVISOR_BLOQUEIO:
      return {
        ...state,
        openModalRevisorBloqueio: action.payload,
      }; 

    case SET_OPEN_MODAL_BLOQUEIO_MODULO:
      return {
        ...state,
        openModalBloqueioModulo: action.payload,
      };
    default:
      return state;
  }
};
